export const COOKIES = {
  AUTH_TOKEN: 'auth-tokens',
  BETA_OPTED_IN: 'beta-opted-in',
  CSU_AUCTION_ACCESS_IDS: 'csuAuctionAccessIds',
  CSU_ECS_IDS: 'csuEcsIds',
  FEATURE_CORE_CLOSING: 'feature.core.tr5.closing',
  FEATURE_CORE_PENDING: 'feature.core.tr5.pending',
  FF_PAYMENTS_ON_HOLD: 'feature.core.payment.on.hold',
  GO_BACK_FROM_SEARCH: 'go-back-to',
  GO_BACK_FROM_TR5_SETTING: 'go-back-to-setting',
  IS_CHAT_ENABLED: 'is-chat-enabled',
  IS_DMP_CHECKOUT_ENABLED: 'isDMPCheckoutEnabled',
  IS_OPTED_INTO_WEB_BETA: 'isOptedIntoWebBeta',
  LIST_PARAMS: 'list-params',
  LIST_PARAMS5: 'list-params5',
  LOCALE: 'tr-locale',
  LOCATION_REFERRER: 'location-referrer',
  LOCATION: 'location',
  REFRESH_TOKEN: 'refresh-tokens',
  SUPER_USER: 'superUser',
  TR4_OKTA_REFRESH_TOKEN: 'tr4-okta-refreshToken',
  TR5_OKTA_REFRESH_TOKEN: 'tr5-okta-refreshToken',
  USER_ID: 'userId',
  SHOULD_REDIRECT_OMP: 'should-redirect-omp'
};

export const DOMAIN = {
  LOCAL: 'localhost',
  TRADEREV: '.traderev.com'
};
